"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.project.manage': 'Zarządzaj projektami',
    'knowledge.project.none': 'Brak projektu',
};
